import {defineStore} from "pinia";
import useCrudStore from "@/store/composables/crud";
import environment from "@/environment";
import httpClient from "@/tools/http-client";
import {ref} from "vue";

export const DEFAULT_ORDERS_PER_PAGE = 5;

export const useOrdersStore
    = defineStore('OrdersStore', () => {
    const ordersEndpoint = environment.appConfig.baseApiUrl + "orders";
    const makeOrderEndpoint = ordersEndpoint + '/make';
    const checkPaymentEndpoint = environment.appConfig.baseApiUrl  + 'check_payment';

    const crud = useCrudStore(ordersEndpoint);

    const checkoutData = ref({
        phone: '',
        fio: '',
        email: '',
    });

    async function makeOrder({ids, delivery_point, comment, email, phone, fio, use_delivery }) {
        crud.startLoading();
        try {
            const resp
                = await httpClient.post(makeOrderEndpoint, {ids, delivery_point, comment, email, phone, fio, use_delivery });
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            crud.setRecord(resp.data.order);
        }catch (e) {
            crud.setError(e);
        }
    }
    async function checkPayment(orderId) {
        crud.startLoading();
        try {
            const resp
                = await httpClient.post(checkPaymentEndpoint, {order_id: orderId});
            return resp.data.message;
        }catch (e) {
            crud.setError(e);
        }
    }
    async function loadData(metaParams) {
        console.log("orders: loadData");
        crud.startLoading();
        try {
            metaParams.page = Number(metaParams.page || 0) + 1;
            metaParams.per_page = Number(metaParams.per_page || DEFAULT_ORDERS_PER_PAGE);

            const resp = await httpClient.get(ordersEndpoint, {params: metaParams});
            if (resp.data.status === 'error') {
                crud.setError(resp.data.message);
                return
            }
            console.log('loaded data',  resp.data.orders )
            crud.addItems(resp.data.orders);
            crud.clearLoading();
        } catch (e) {
            crud.setError(e);
        }
    }

    return {
        ...crud,
        makeOrder,
        checkPayment,
        loadData,
        checkoutData
    }
});
